import React, {useCallback, useContext, useEffect, useMemo, useRef, useState} from 'react';
import {Box, Card, CardContent, Chip, CircularProgress, Switch, TextField, Typography} from "@mui/material";
import {cancelChipStyle} from "../../ButtonStyle/Cancel";
import {addChipStyle} from "../../ButtonStyle/Add";

import {useNavigate} from "react-router-dom";
import usePA_GlobalStore from "../../../Services/ZustandGlobalStore";
import {PAContext} from "../../../Services/PAContext";
import dayjs from "dayjs";
import {DateCalendar} from "@mui/x-date-pickers";
import {CloudUpload as CloudUploadIcon, Close as CloseIcon} from '@mui/icons-material';
import {useDropzone} from "react-dropzone";
import Papa from "papaparse";
import * as XLSX from 'xlsx';
import * as pdfjsLib from "pdfjs-dist/webpack.mjs";
import AccountDocument from "../../../MasterEventObjects/Document";
import {addAccountDocument, addEventDocument} from "./BrowserDatabaseFunctions";
import './documents.css';
import IconButton from "@mui/material/IconButton";


const keyStr = "ABCDEFGHIJKLMNOP" +
    "QRSTUVWXYZabcdef" +
    "ghijklmnopqrstuv" +
    "wxyz0123456789+/" +
    "=";
function encode64(input) {
    input = escape(input);
    let output = "";
    let chr1, chr2, chr3 = "";
    let enc1, enc2, enc3, enc4 = "";
    let i = 0;

    do {
        chr1 = input.charCodeAt(i++);
        chr2 = input.charCodeAt(i++);
        chr3 = input.charCodeAt(i++);

        enc1 = chr1 >> 2;
        enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
        enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
        enc4 = chr3 & 63;

        if (isNaN(chr2)) {
            enc3 = enc4 = 64;
        } else if (isNaN(chr3)) {
            enc4 = 64;
        }

        output = output +
            keyStr.charAt(enc1) +
            keyStr.charAt(enc2) +
            keyStr.charAt(enc3) +
            keyStr.charAt(enc4);
        chr1 = chr2 = chr3 = "";
        enc1 = enc2 = enc3 = enc4 = "";
    } while (i < input.length);

    return output;
}



function DocumentAddNew(){

    const navigate = useNavigate();

    const { PA_GlobalObject, set_PA_GlobalObject } = usePA_GlobalStore();

    const { dataArray, registerDocumentBinary, setAccountDocumentArray, sendSocketMessage } = useContext(PAContext);
    const { Account, Attendees, SampleAttendees, authenticated } = dataArray; // Fetch event attendees

    const [ attendeesReferenceArray, setAttendeesReferenceArray ] = useState( authenticated ? Attendees : SampleAttendees);
    useEffect(() => {
        setAttendeesReferenceArray(authenticated ? Attendees : SampleAttendees);
    }, [authenticated, Attendees, SampleAttendees]);

    // 1. Get the actual guest list from the Event
    const eventAttendees = useMemo(() => {
        return PA_GlobalObject?.Planning?.attendees || [];
    }, [PA_GlobalObject?.Planning?.attendees]);

    // 2. Find the current user's role in THIS event
    const isAuthorizedToDistribute = useMemo(() => {
        const me = eventAttendees.find(att => att.id === Account?.id);
        const role = me?.role?.toLowerCase();
        return role === "admin" || role === "master_admin" || role === "planner";
    }, [eventAttendees, Account?.id]);


    const [title, setTitle] = useState("");

    const [passcodeProtected, setPasscodeProtected] = useState(false);
    const [passcode, setPasscode] = useState("");
    const [passcodeConfirm, setPasscodeConfirm] = useState("");
    const [showPasscode, setShowPasscode] = useState(false);
    const inputType = showPasscode ? 'text' : 'password';

    const [isPrivate, setIsPrivate] = useState(true);

    const [hasExpirationDate, setHasExpirationDate] = useState(false);
    const [expirationDate, setExpirationDate] = useState("");

    const [accountOrEvent, setAccountOrEvent] = useState("event");

    const [documentFile, setDocumentFile] = useState(null);
    const [ documentName, setDocumentName ] = useState('');
    const [ documentType, setDocumentType ] = useState('');
    const [ documentSize, setDocumentSize ] = useState('');
    const [ documentData, setDocumentData ] = useState('');
    const [ documentDataCategory, setDocumentDataCategory ] = useState('');


    const [previewResult, setPreviewResult] = useState({ type: 'none', data: null });
    const [isProcessing, setIsProcessing] = useState(false);


    const formatFileSize = (size) => {
        const units = ['B', 'KB', 'MB', 'GB', 'TB'];
        let unitIndex = 0;
        let s = size;
        while (s >= 1024 && unitIndex < units.length - 1) {
            s /= 1024;
            unitIndex++;
        }
        return `${s.toFixed(2)} ${units[unitIndex]}`;
    };
    const isImage = (type) => type.startsWith('image/');
    const isPdf = (type) => type === 'application/pdf';
    const isCsv = (name) => (name.split('.').pop() || '').toLowerCase() === 'csv';
    const isExcel = (name) => ['xls', 'xlsx'].includes((name.split('.').pop() || '').toLowerCase());
    const isTextLike = (type, name) => {
        const ext = (name.split('.').pop() || '').toLowerCase();
        // Check for common text/code extensions
        return type.startsWith('text/') || ['xml', 'txt', 'css', 'js', 'html', 'json', 'eml', 'doc', 'docx'].includes(ext);
    };

    const parseCsv = (text) => {

        // CRITICAL CHECK: Ensure we received a string, not a Blob/File object.
        if (typeof text !== 'string') {
            console.error("parseCsv failed: Input data is not a string (received type:", typeof text, "). Expected file content.");
            return { type: 'error', data: 'Invalid data type for CSV parsing. Input must be file content (string), not a File object.' };
        }

        if (typeof Papa === 'undefined') return { type: 'error', data: 'PapaParse not available for CSV parsing. Check CDN script.' };

        try {
            // PapaParse works with the raw text string directly.
            const result = Papa.parse(text, { header: true, skipEmptyLines: true });
            const rows = result.data;
            const headers = result.meta.fields;

            if (!headers || headers.length === 0) {
                return { type: 'error', data: 'Could not detect CSV headers. Check file format.' };
            }
            return { type: 'table', data: { headers, rows, title: 'CSV Data Preview' } };
        } catch (e) {
            return { type: 'text', data: { text: text, name: 'CSV Parsing Failed (showing raw text)' } };
        }
    };
    const parseExcel = (arrayBuffer) => {
        console.log("parseExcel : ", arrayBuffer);
        // Debugging: Log the byte length of the ArrayBuffer to confirm data receipt.
        console.log("parseExcel received ArrayBuffer. Byte Length:", arrayBuffer?.byteLength);

        if (typeof XLSX === 'undefined') return { type: 'error', data: 'SheetJS (XLSX) not available for Excel parsing. Check CDN script.' };

        // Check for empty or invalid buffer before attempting to read
        if (!arrayBuffer || arrayBuffer.byteLength === 0) {
            return { type: 'error', data: 'File buffer is empty or invalid.' };
        }

        try {
            const workbook = XLSX.read(arrayBuffer, { type: 'array' });
            const sheetName = workbook.SheetNames[0];
            const sheet = workbook.Sheets[sheetName];

            if (!sheet) return { type: 'error', data: 'Excel workbook is empty.' };

            const aoa = XLSX.utils.sheet_to_json(sheet, { header: 1 });
            if (!aoa || aoa.length === 0) {
                return { type: 'error', data: 'Sheet is empty.' };
            }

            const headers = aoa[0].map(h => String(h).trim() || 'Col');
            // We use range: 1 to skip the header row when converting to JSON objects
            const rows = XLSX.utils.sheet_to_json(sheet, { header: headers, range: 1 });

            return { type: 'table', data: { headers, rows, title: `Excel Data Preview (Sheet: ${sheetName})` } };

        } catch (e) {
            // Debugging: Log the full error object for better insight into the SheetJS failure
            console.error("XLSX Parsing Error:", e);
            return { type: 'error', data: `Failed to read Excel file. Error: ${e.message}` };
        }
    };
    const PdfRenderer = ({ dataUrl }) => {
        console.log("PdfRenderer");
        const [pdfLoading, setPdfLoading] = useState(true);
        const containerRef = React.useRef(null);

        useEffect(() => {
            const renderPdf = async () => {
                if (!dataUrl || typeof pdfjsLib === 'undefined' || !containerRef.current) {
                    setPdfLoading(false);
                    if (containerRef.current) {
                        containerRef.current.innerHTML = `<p style="text-align:center; color: #d32f2f; padding: 10px;">PDF.js library not found. Cannot render preview.</p>`;
                    }
                    return;
                }

                setPdfLoading(true);
                containerRef.current.innerHTML = ''; // Clear container

                try {
                    // pdfjsLib is assumed global
                    const pdf = await pdfjsLib.getDocument({ url: dataUrl }).promise;
                    const pagesToRender = Math.min(pdf.numPages, 3);

                    for (let i = 1; i <= pagesToRender; i++) {
                        const page = await pdf.getPage(i);

                        // Use a reasonable default width or container width
                        const containerWidth = containerRef.current.clientWidth || 300;
                        const initialViewport = page.getViewport({ scale: 1 });
                        const scale = Math.min(containerWidth / initialViewport.width, 2);
                        const viewport = page.getViewport({ scale });

                        const canvas = document.createElement('canvas');
                        canvas.style.display = 'block';
                        canvas.style.margin = '5px auto';
                        canvas.style.maxWidth = '100%';
                        canvas.style.height = 'auto';
                        canvas.width = Math.floor(viewport.width);
                        canvas.height = Math.floor(viewport.height);

                        containerRef.current.appendChild(canvas);

                        const context = canvas.getContext('2d');
                        await page.render({ canvasContext: context, viewport }).promise;
                    }

                    if (pdf.numPages > 3 && containerRef.current) {
                        const p = document.createElement('p');
                        p.style.fontSize = '12px';
                        p.style.textAlign = 'center';
                        p.style.color = '#757575';
                        p.textContent = '(Preview limited to first 3 pages)';
                        containerRef.current.appendChild(p);
                    }

                } catch (error) {
                    console.error("Error rendering PDF:", error);
                    if (containerRef.current) {
                        containerRef.current.innerHTML = `<p style="text-align:center; color: #d32f2f; padding: 10px;">Error loading PDF: ${error.message}</p>`;
                    }
                } finally {
                    setPdfLoading(false);
                }
            };

            renderPdf();
        }, [dataUrl]);

        return (
            <Box sx={{ maxHeight: 400, overflowY: 'auto', p: 1 }}>
                {pdfLoading && (
                    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 100, color: 'primary.main' }}>
                        <CircularProgress size={20} sx={{ mr: 1 }} />
                        <Typography variant="caption">Loading PDF Preview...</Typography>
                    </Box>
                )}
                <div ref={containerRef}>
                </div>
            </Box>
        );
    };
    const TableRenderer = ({ headers, rows, title }) => {
        const limitedHeaders = headers.slice(0, 5);
        const limitedRows = rows.slice(0, 10);
        const isLimited = rows.length > 10 || headers.length > 5;

        return (
            <Box>
                <Typography variant="caption" sx={{ color: 'text.secondary', mb: 1, display: 'block' }}>{title}</Typography>
                <Box sx={{ maxHeight: 350, overflow: 'auto', border: '1px solid #eee', borderRadius: 1 }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                        <thead style={{ position: 'sticky', top: 0, backgroundColor: '#f5f5f5', boxShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
                        <tr>
                            {limitedHeaders.map((h, i) => (
                                <th key={i} style={{ padding: '8px', textAlign: 'left', fontWeight: 'bold', borderBottom: '1px solid #ddd' }}>{h}</th>
                            ))}
                        </tr>
                        </thead>
                        <tbody>
                        {limitedRows.map((row, i) => (
                            <tr key={i} style={{ borderBottom: '1px solid #eee' }}>
                                {limitedHeaders.map((h, j) => (
                                    <td key={j} style={{ padding: '8px', color: '#424242', maxWidth: 150, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                                        {row[h] !== undefined ? String(row[h]) : ''}
                                    </td>
                                ))}
                            </tr>
                        ))}
                        </tbody>
                    </table>
                </Box>
                {isLimited && (
                    <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block', textAlign: 'center' }}>Preview limited to 10 rows and 5 columns.</Typography>
                )}
            </Box>
        );
    };
    const onDrop = useCallback((acceptedFiles) => {
        if (acceptedFiles.length === 0) return;

        // Reset States
        setDocumentFile(null);
        setDocumentName('');
        setDocumentType('');
        setDocumentSize('');
        setDocumentData(''); // This will store our raw ArrayBuffer
        setDocumentDataCategory('');
        setPreviewResult({ type: 'loading', data: 'Processing file...' });
        setIsProcessing(true);

        const selectedFile = acceptedFiles[0];
        const fileName = selectedFile.name;
        const fileType = selectedFile.type;

        // Set Metadata
        setDocumentFile(selectedFile);
        setDocumentName(fileName);
        setDocumentType(fileType);
        setDocumentSize(formatFileSize(selectedFile.size));

        // 🎯 1. ALWAYS read the raw ArrayBuffer for the Vault (Encryption/Upload)
        const binaryReader = new FileReader();
        binaryReader.onload = (e) => {
            setDocumentData(e.target.result); // ArrayBuffer locked in for PA_Crypto
        };
        binaryReader.readAsArrayBuffer(selectedFile);


        // 🎯 2. Run PREVIEW Logic in parallel
        // Text-based files (CSV, TXT, JSON, HTML)
        if (isTextLike(fileType, fileName)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const fileContent = e.target.result;
                setIsProcessing(false);

                if (isCsv(fileName)) {
                    setPreviewResult(parseCsv(fileContent));
                    setDocumentDataCategory('csv');
                } else if (fileType === 'text/html' || fileName.toLowerCase().endsWith('.html')) {
                    setPreviewResult({ type: 'html', data: { text: fileContent, name: fileName } });
                    setDocumentDataCategory('html');
                } else {
                    setPreviewResult({ type: 'text', data: { text: fileContent, name: fileName } });
                    setDocumentDataCategory('text');
                }
            };
            reader.readAsText(selectedFile);
        }
        // Excel files
        else if (isExcel(fileName)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                setPreviewResult(parseExcel(data));
                setIsProcessing(false);
                setDocumentDataCategory('xls');
            };
            reader.readAsArrayBuffer(selectedFile);
        }
        // Binary files for Preview (PDF, Image) - We need DataURLs for the <img> and <embed> tags
        else if (isImage(fileType) || isPdf(fileType)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setIsProcessing(false);
                if (isPdf(fileType)) {
                    setPreviewResult({ type: 'pdf', data: e.target.result });
                    setDocumentDataCategory('pdf');
                } else { // Image
                    setPreviewResult({ type: 'image', data: e.target.result });
                    setDocumentDataCategory('image');
                }
            };
            reader.readAsDataURL(selectedFile);
        }
        // Unsupported files (still capture binary, just no preview)
        else {
            setPreviewResult({ type: 'unsupported', data: { name: fileName, type: fileType } });
            setDocumentDataCategory('unsupported');
            setIsProcessing(false);
        }

    }, []);
    const onDropOLD = useCallback((acceptedFiles) => {
        if (acceptedFiles.length === 0) return;

        setDocumentFile(null);
        setDocumentName('');
        setDocumentType('');
        setDocumentSize('');
        setDocumentData('');
        setDocumentDataCategory('');
        setPreviewResult({ type: 'loading', data: 'Processing file...' });
        setIsProcessing(true);


        const selectedFile = acceptedFiles[0];

        setDocumentFile(selectedFile);
        setDocumentName(selectedFile.name);
        setDocumentType(selectedFile.type);
        setDocumentSize(formatFileSize(selectedFile.size));

        const fileName = selectedFile.name;
        const fileType = selectedFile.type;

        console.log("fileName : ", fileName);
        console.log("fileType : ", fileType);

        // Text-based files (CSV, TXT, JSON, DOCX/DOC (read as text))
        if (isTextLike(fileType, fileName)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const fileContent = e.target.result;
                setDocumentData(fileContent);
                setIsProcessing(false);

                if (isCsv(fileName)) {
                    setPreviewResult(parseCsv(fileContent));
                    setDocumentDataCategory('csv');
                } else if (fileType === 'text/html' || fileName.toLowerCase().endsWith('.html')) {
                    // CRITICAL: Set type to 'html' for dangerous rendering
                    setPreviewResult({ type: 'html', data: { text: fileContent, name: fileName } });
                    setDocumentDataCategory('html');
                } else {
                    setPreviewResult({ type: 'text', data: { text: fileContent, name: fileName } });
                    setDocumentDataCategory('text');
                }
            };
            reader.readAsText(selectedFile);
        }
        // Excel files (Binary format, but we mock the parsing)
        else if (isExcel(fileName)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                const data = new Uint8Array(e.target.result);
                setDocumentData(data);
                setPreviewResult(parseExcel(data));
                setIsProcessing(false);
                setDocumentDataCategory('xls');
            };
            reader.readAsArrayBuffer(selectedFile);
        }
        // Binary files that need a Data URL (PDF, Image)
        else if (isImage(fileType) || isPdf(fileType)) {
            const reader = new FileReader();
            reader.onload = (e) => {
                setDocumentData(e.target.result);
                setIsProcessing(false);
                if (isPdf(fileType)) {
                    setPreviewResult({ type: 'pdf', data: e.target.result });
                    setDocumentDataCategory('pdf');
                } else { // Image
                    setPreviewResult({ type: 'image', data: e.target.result });
                    setDocumentDataCategory('image');
                }
            };
            reader.readAsDataURL(selectedFile);
        }
        // Unsupported files
        else {
            setPreviewResult({ type: 'unsupported', data: { name: fileName, type: fileType } });
            setDocumentDataCategory('unsupported');
            setIsProcessing(false);
        }

    }, []);
    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': ['.pdf'],
            'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp', '.svg'],
            'message/rfc822': ['.eml'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            'application/msword': ['.doc'],
            'application/vnd.ms-excel': ['.xls'],
            'text/plain': ['.txt', '.csv'],
            'application/json': ['.json'],
            'text/html': ['.html'],
            'text/css': ['.css'],
            'text/javascript': ['.js'],
            'application/xml': ['.xml']
        },
        multiple: false,
    });

    const [selectedAttendeeIds, setSelectedAttendeeIds] = useState([Account.id]);

    const [notes, setNotes] = useState("");


    function handleTitleChange(event){
        setTitle(event.target.value);
    }

    function handleDocumentPasscodeProtectedChange(event){
        setPasscodeProtected(event.target.checked);
        if (!event.target.checked){
            //clear any passcodes
            setPasscode('');
            setPasscodeConfirm('');
        }
    }
    function handlePasscodeChange(event){
        setPasscode(event.target.value);
    }
    function handlePasscodeConfirmChange(event){
        setPasscodeConfirm(event.target.value);
    }
    function togglePasscodeVisibility(){
        setShowPasscode(prev => !prev);
    }

    function handleDocumentIsPrivateChange(){
        setIsPrivate(!isPrivate);
    }

    function handleDocumentExpirationDateChange(event){
        setHasExpirationDate(event.target.checked);
        if (!event.target.checked){
            //clear the expiration date if toggle off
            setExpirationDate('');
        }
    }
    function handleDocumentExpirationDateSelected(date){
        setExpirationDate(date);
    }

    function toggleAccountOrEvent(purpose){
        setAccountOrEvent(purpose);
        if (purpose === 1) { // 1 = Account
            // Reset to only the current user if they switch to Account mode
            setSelectedAttendeeIds([Account.id]);
            setIsPrivate(true); // Usually Account docs should default to private
        }
    }


    const FileDetail = ({ label, value }) => (
        <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            py: 0.5,
            borderBottom: '1px solid #eeeeee',
            '&:last-child': { borderBottom: 'none' }
        }}>
            <Typography variant="caption" sx={{ color: 'text.secondary', fontWeight: 500 }}>
                {label}
            </Typography>
            {/* Using component="div" here allows 'value' to be a Chip component or a simple string */}
            <Typography variant="caption" component="div" sx={{ textAlign: 'right', fontWeight: label === 'File Name' ? 'bold' : 'normal' }}>
                {value}
            </Typography>
        </Box>
    );
    const renderPreview = useMemo(() => {
        console.log("renderPreview");
        const { type, data } = previewResult;

        console.log("type : ", type);

        if (isProcessing) {
            return (
                <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 150, color: 'primary.main' }}>
                    <CircularProgress />
                    <Typography variant="body2" sx={{ ml: 2 }}>{data || 'Processing file...'}</Typography>
                </Box>
            );
        }

        switch (type) {
            case 'image':
                return (
                    <Box sx={{ display: 'flex', justifyContent: 'center', p: 2 }}>
                        <img
                            src={data}
                            alt="Preview"
                            style={{ maxWidth: '100%', maxHeight: 350, borderRadius: '8px', boxShadow: '0 2px 5px rgba(0,0,0,0.1)' }}
                        />
                    </Box>
                );
            case 'pdf':
                return <PdfRenderer dataUrl={data} />;
            case 'table':
                return <TableRenderer headers={data.headers} rows={data.rows} title={data.title} />;
            case 'html':
                return (
                    <Box sx={{ p: 1, border: '1px solid #e0e0e0', borderRadius: 1, bgcolor: '#fafafa', maxHeight: 400, overflow: 'auto' }}>
                        <Typography variant="caption" sx={{ color: 'error.main', mb: 1, display: 'block', fontWeight: 'bold', textAlign: 'center' }}>
                            Warning: HTML content is rendered directly and may be unstable or unsafe.
                        </Typography>
                        <Box
                            // DANGER: Rendering raw HTML content.
                            dangerouslySetInnerHTML={{ __html: data.text }}
                        />
                    </Box>
                );
            case 'text':
                const limitedText = data.text.substring(0, 5000) + (data.text.length > 5000 ? '\n\n... (preview truncated)' : '');
                return (
                    <Box sx={{ p: 1, border: '1px solid #e0e0e0', borderRadius: 1, bgcolor: '#fafafa', maxHeight: 300, overflow: 'auto' }}>
                        <Typography variant="caption" sx={{ color: 'text.secondary', mb: 1, display: 'block', fontWeight: 'bold' }}>Text Preview ({data.name})</Typography>
                        <Box component="pre" sx={{ fontSize: '10px', whiteSpace: 'pre-wrap', p: 1, bgcolor: '#fff', borderRadius: 0.5, border: '1px solid #f0f0f0', color: '#424242' }}>
                            {limitedText}
                        </Box>
                        {data.text.length > 5000 && <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block', textAlign: 'center' }}>Showing first 5000 characters.</Typography>}
                    </Box>
                );
            case 'error':
                return (
                    <Box sx={{ textAlign: 'center', p: 3, bgcolor: '#ffebee', border: '1px solid #ef9a9a', borderRadius: 1 }}>
                        <Typography variant="subtitle2" color="error" gutterBottom>Parsing Error</Typography>
                        <Typography variant="caption" color="text.secondary">{data}</Typography>
                    </Box>
                );
            case 'unsupported':
                return (
                    <Box sx={{ textAlign: 'center', p: 3, bgcolor: '#e0f7fa', border: '1px solid #80deea', borderRadius: 1 }}>
                        <Typography variant="subtitle2" sx={{ color: '#00bcd4' }} gutterBottom>Unsupported File Type</Typography>
                        <Typography variant="caption" color="text.secondary">No inline preview available for: {data.name} ({data.type || 'Unknown'}).</Typography>
                    </Box>
                );
            case 'none':
            default:
                return (
                    <Box sx={{ height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center', color: 'text.disabled' }}>
                        <Typography variant="body2">No file selected for preview.</Typography>
                    </Box>
                );
        }
    }, [previewResult, isProcessing]);
    function handleClearDocument() {
        setDocumentFile(null);
        setDocumentName('');
        setDocumentType('');
        setDocumentSize('');
        setDocumentData('');
        setPreviewResult({ type: 'none', data: null });
        setIsProcessing(false);
    }

    const handleAttendeeToggle = (id) => {
        setSelectedAttendeeIds(prev =>
            prev.includes(id)
                ? prev.filter(item => item !== id) // Remove if already there
                : [...prev, id] // Add if not there
        );
    };

    function handleNotesChange(event){
        setNotes(event.target.value);
    }


    function handleDocumentAddOK() {
        if (title.trim() === '') return alert("Document title is required.");
        if (selectedAttendeeIds.length === 0) return alert("Please select at least one recipient.");
        if (passcodeProtected) {
            if (!passcode || passcode.trim() === "") {
                return alert("Please enter a passcode to secure this document.");
            }
            if (passcode !== passcodeConfirm) {
                return alert("Passcodes do not match. Please verify.");
            }
        }

        const _new_document = new AccountDocument();

        _new_document.created_by = Account.id;
        _new_document.name = title;
        _new_document.private = isPrivate;
        _new_document.passcode_needed = passcodeProtected;
        _new_document.expires = hasExpirationDate ? expirationDate : '';
        _new_document.notes = notes;
        _new_document.status = accountOrEvent === 'account' ? 1 : 2;
        _new_document.is_finalized = false;

        // Metadata only
        _new_document.file_name = documentName;
        _new_document.file_type = documentType;
        _new_document.file_size = documentSize;
        _new_document.data_category = documentDataCategory;

        console.log("_new_document : ", _new_document);


        // 🎯 STEP 1: Store raw data AND passcode in local Ref
        registerDocumentBinary(_new_document.id, {
            raw_binary: documentData,
            passcode: passcodeProtected ? passcode : '',
            file_type: documentType,
            selected_attendee_ids: selectedAttendeeIds,
            metadata: _new_document
        });

        // 🎯 STEP 2: Add to local state (UI shows immediate feedback)
        // Use a placeholder or loading state for 'data'
        const docWithPlaceholder = { ..._new_document, data: 'uploading...' };

        if (accountOrEvent === 'account') {
            const currentDocuments = Account?.documents || [];
            setAccountDocumentArray([docWithPlaceholder, ...currentDocuments]);
        } else {
            // 🎯 Create a unique copy for each selected attendee
            const distributedDocs = selectedAttendeeIds.map(attendeeId => ({
                ...docWithPlaceholder,
                id: `${docWithPlaceholder.id}_${attendeeId}`, // Temp unique ID for local mapping
                attendee_id: attendeeId,
                temp_id: docWithPlaceholder.id // Keep reference to the original request ID
            }));

            set_PA_GlobalObject(prev => ({
                ...prev,
                Planning: {
                    ...prev.Planning,
                    documents: [...distributedDocs, ...(prev.Planning.documents || []) ]
                }
            }));
        }

        // 🎯 STEP 3: Request the GCS Upload URL
        if (PA_GlobalObject.Planning.status !== 10) {

            sendSocketMessage({
                action: accountOrEvent === 'account'
                    ? "E_requestAccountDocumentUploadUrlForGCS"
                    : "E_requestEventDocumentUploadUrlForGCS",
                event_id: PA_GlobalObject.Planning.id,
                document_id: _new_document.id,
                file_name: documentName,
                file_type: documentType
            });
        }

        navigate('/Planner/Documents');
    }

    function handlePromptAddNewClose() {
        navigate('/Planner/Documents');
    }




    return (
        /* Main wrapper: fixed height, no internal scroll here */
        <div className="documents-list-container" style={{
            backgroundColor: '#f8f9fa',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden' // Prevent the whole page from bouncing
        }}>

            {/* 🎯 HEADER: Fixed at the top */}
            <Box sx={{
                flexShrink: 0, // Prevents header from shrinking
                zIndex: 100,
                background: 'rgba(255, 255, 255, 0.9)',
                backdropFilter: 'blur(10px)',
                p: '12px 16px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                borderBottom: '1px solid #eef0f2'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 900, color: '#151269', lineHeight: 1 }}>
                        New Item
                    </Typography>
                    <Typography variant="caption" sx={{ color: '#888', fontWeight: 700, fontSize: '9px' }}>
                        VAULT SECURE
                    </Typography>
                </Box>
                <Box sx={{ display: 'flex', gap: 1 }}>
                    <Chip
                        sx={{ ...cancelChipStyle, height: '28px', fontSize: '11px' }}
                        label="Back"
                        onClick={handlePromptAddNewClose}
                    />
                    <Chip
                        sx={{ ...addChipStyle, height: '28px', fontSize: '11px', fontWeight: 800 }}
                        label="Save"
                        onClick={handleDocumentAddOK}
                    />
                </Box>
            </Box>

            {/* 📜 SCROLLABLE CONTENT AREA */}
            <div className="documents-add-new-item-container" style={{
                flexGrow: 1,
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch' // Smooth scroll for iOS
            }}>
                <Box sx={{ p: '16px', pb: '80px' }}> {/* Extra bottom padding for comfortable scrolling */}

                    {/* 1. IDENTITY SECTION */}
                    <Typography variant="overline" sx={{ fontWeight: 800, color: '#151269', opacity: 0.6, display: 'block', mb: 0.5 }}>Identity</Typography>
                    <Card sx={{ borderRadius: '16px', boxShadow: 'none', border: '1px solid #e0e4e8', mb: 2 }}>
                        <CardContent sx={{ p: '12px !important' }}>
                            <TextField
                                variant="standard"
                                placeholder="Document Title"
                                fullWidth
                                value={title}
                                onChange={handleTitleChange}
                                InputProps={{ disableUnderline: true, sx: { fontSize: '16px', fontWeight: 700, color: '#151269' } }}
                            />
                            <Box sx={{ height: '1px', bgcolor: '#eee', my: 1 }} />
                            <TextField
                                placeholder="Notes (Optional)"
                                fullWidth
                                multiline
                                rows={2}
                                value={notes}
                                onChange={handleNotesChange}
                                variant="standard"
                                InputProps={{ disableUnderline: true, sx: { fontSize: '13px', color: '#666' } }}
                            />
                        </CardContent>
                    </Card>


                    {/* 2. SECURITY SECTION */}
                    <Typography variant="overline" sx={{ fontWeight: 800, color: '#151269', opacity: 0.6, display: 'block', mb: 0.5 }}>Protection</Typography>
                    <Card sx={{
                        borderRadius: '16px',
                        border: passcodeProtected ? '2px solid #9c27b0' : '1px solid #e0e4e8',
                        boxShadow: 'none',
                        mb: 2,
                        overflow: 'hidden'
                    }}>
                        <Box sx={{ p: '12px' }}>
                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <Typography sx={{ fontWeight: 700, fontSize: '13px', color: '#151269' }}>Assign Passcode</Typography>
                                <Switch size="small" checked={passcodeProtected} onChange={handleDocumentPasscodeProtectedChange} color="secondary" />
                            </Box>

                            {passcodeProtected && (
                                <Box sx={{ mt: 1 }}>
                                    <TextField
                                        label="Passcode"
                                        type={inputType}
                                        fullWidth
                                        size="small"
                                        value={passcode}
                                        onChange={handlePasscodeChange}
                                        sx={{ mb: 1.5, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                    />
                                    <TextField
                                        label="Confirm"
                                        type={inputType}
                                        fullWidth
                                        size="small"
                                        value={passcodeConfirm}
                                        onChange={handlePasscodeConfirmChange}
                                        error={passcodeConfirm && passcode !== passcodeConfirm}
                                        sx={{ mb: 1, '& .MuiOutlinedInput-root': { borderRadius: '8px' } }}
                                    />
                                    <Box onClick={togglePasscodeVisibility} sx={{ display: 'flex', alignItems: 'center', mb: 1.5, cursor: 'pointer' }}>
                                        <i className={showPasscode ? "icon-eye-cross" : "icon-eye"} style={{ color: '#9c27b0', fontSize: '12px', marginRight: '6px' }} />
                                        <Typography sx={{ fontSize: '10px', fontWeight: 800, color: '#9c27b0' }}>{showPasscode ? 'HIDE' : 'SHOW'}</Typography>
                                    </Box>
                                    <Box sx={{ bgcolor: '#fff4e5', p: 1, borderRadius: '8px', border: '1px solid #ffd591' }}>
                                        <Typography sx={{ fontSize: '10px', lineHeight: 1.3, color: '#8c4d00', fontWeight: 600 }}>
                                            Notice: Passcode is used for local encryption. We don't store it.
                                        </Typography>
                                    </Box>
                                </Box>
                            )}

                            <Box sx={{ height: '1px', bgcolor: '#eee', my: 1.5 }} />

                            <Box display="flex" alignItems="center" justifyContent="space-between">
                                <Typography sx={{ fontWeight: 700, fontSize: '13px', color: '#151269' }}>
                                    {isPrivate ? 'Private Item' : 'Public Item'}
                                </Typography>
                                <Switch size="small" checked={isPrivate} onChange={handleDocumentIsPrivateChange} />
                            </Box>
                        </Box>
                    </Card>

                    {/* 3. STORAGE LOCATION */}
                    <Typography variant="overline" sx={{ fontWeight: 800, color: '#151269', opacity: 0.6, display: 'block', mb: 0.5 }}>
                        Vault Location
                    </Typography>

                    <Card sx={{ borderRadius: '16px', border: '1px solid #e0e4e8', mb: 2, overflow: 'hidden' }}>
                        {/* Side-by-Side Toggle Container */}
                        <Box sx={{
                            display: 'flex',
                            p: 0.5,
                            bgcolor: '#f1f3f5', // Light grey track
                            gap: 0.5
                        }}>
                            <Box
                                onClick={() => toggleAccountOrEvent('event')}
                                sx={{
                                    flex: 1,
                                    py: 1,
                                    borderRadius: '12px',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    transition: 'all 0.2s ease',
                                    bgcolor: accountOrEvent === 'event' ? '#151269' : 'transparent',
                                    color: accountOrEvent === 'event' ? '#fff' : '#666',
                                    boxShadow: accountOrEvent === 'event' ? '0 4px 12px rgba(21, 18, 105, 0.2)' : 'none',
                                }}
                            >
                                <Typography variant="caption" sx={{ fontWeight: 800, letterSpacing: '0.5px' }}>EVENT</Typography>
                            </Box>
                            <Box
                                onClick={() => toggleAccountOrEvent('account')}
                                sx={{
                                    flex: 1,
                                    py: 1,
                                    borderRadius: '12px',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    transition: 'all 0.2s ease',
                                    bgcolor: accountOrEvent === 'account' ? '#151269' : 'transparent',
                                    color: accountOrEvent === 'account' ? '#fff' : '#666',
                                    boxShadow: accountOrEvent === 'account' ? '0 4px 12px rgba(21, 18, 105, 0.2)' : 'none',
                                }}
                            >
                                <Typography variant="caption" sx={{ fontWeight: 800, letterSpacing: '0.5px' }}>ACCOUNT</Typography>
                            </Box>
                        </Box>

                        {/* The Descriptive Notice */}
                        <Box sx={{ p: 1.5, bgcolor: '#fff' }}>
                            <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5 }}>
                                <i
                                    className={accountOrEvent === 'account' ? "icon-lock" : "icon-share"}
                                    style={{ color: '#151269', fontSize: '16px', marginTop: '2px' }}
                                />
                                <Box>
                                    <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#151269' }}>
                                        {accountOrEvent === 'account' ? "Global Private Vault" : "Event Distribution"}
                                    </Typography>
                                    <Typography sx={{ fontSize: '10.5px', color: '#666', lineHeight: 1.4 }}>
                                        {accountOrEvent === 'account'
                                            ? "This document will be saved to your personal profile. It is not shared with other attendees and follows you to every event."
                                            : "This document is specific to this Event. You can select multiple recipients below to distribute secure copies to their vaults."}
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Card>

                    {/* RECIPIENT SELECTION */}
                    {(accountOrEvent === "event" && isAuthorizedToDistribute) && (
                        <>
                            <Typography variant="overline" sx={{ fontWeight: 800, color: '#151269', opacity: 0.6, display: 'block', mb: 0.5 }}>
                                Add To Recipients
                            </Typography>
                            <Card sx={{ borderRadius: '16px', border: '1px solid #e0e4e8', mb: 2, p: '12px' }}>
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                    {eventAttendees.map((att) => {
                                        const isSelected = selectedAttendeeIds.includes(att.id);
                                        // Standardize name display from the Event Attendee object
                                        const displayName = att.id === Account.id
                                            ? "Myself"
                                            : `${att.nickname || ''}`.trim() || att.email || "Guest";

                                        return (
                                            <Chip
                                                key={att.id}
                                                label={displayName}
                                                onClick={() => handleAttendeeToggle(att.id)}
                                                variant={isSelected ? "filled" : "outlined"}
                                                sx={{
                                                    fontWeight: isSelected ? 800 : 400,
                                                    borderRadius: '8px',
                                                    transition: 'all 0.2s',
                                                    bgcolor: isSelected ? '#151269' : 'transparent',
                                                    color: isSelected ? '#fff' : 'rgba(0,0,0,0.6)',
                                                    border: isSelected ? '1px solid #151269' : '1px solid #e0e4e8',
                                                    '&:hover': { bgcolor: isSelected ? '#0a084d' : '#f0f0f0' }
                                                }}
                                            />
                                        );
                                    })}
                                </Box>

                                <Box sx={{ mt: 1.5, p: 1, bgcolor: '#f0f7ff', borderRadius: '8px', border: '1px solid #d0e3ff' }}>
                                    <Typography variant="caption" sx={{ color: '#0052cc', fontWeight: 700, fontSize: '10px', display: 'flex', alignItems: 'center', gap: 0.5 }}>
                                        <i className="icon-info" style={{ fontSize: '12px' }} />
                                        {selectedAttendeeIds.length === 0
                                            ? "Select at least one attendee to share this document with."
                                            : `Adding to ${selectedAttendeeIds.length} event member${selectedAttendeeIds.length===1? '': 's'}.`}
                                    </Typography>
                                </Box>
                            </Card>
                        </>
                    )}

                    {/* EXPIRY */}
                    <Typography variant="overline" sx={{ fontWeight: 800, color: '#151269', opacity: 0.6, display: 'block', mb: 0.5 }}>Expiry</Typography>

                    <Card sx={{ borderRadius: '16px', border: '1px solid #e0e4e8', mb: 2, p: '12px' }}>
                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Typography sx={{ fontWeight: 700, fontSize: '13px', color: '#151269' }}>Track Expiration</Typography>
                            <Switch size="small" checked={hasExpirationDate} onChange={handleDocumentExpirationDateChange} />
                        </Box>
                        {hasExpirationDate && (
                            <Box sx={{ mt: 1 }}>
                                <DateCalendar
                                    sx={{ width: '100%', '& .MuiPickersCalendarHeader-root': { p: 0 } }}
                                    value={expirationDate || dayjs()}
                                    onChange={handleDocumentExpirationDateSelected}
                                />
                            </Box>
                        )}
                    </Card>



                    {/* 4. FILE SECTION */}
                    <Typography variant="overline" sx={{ fontWeight: 800, color: '#151269', opacity: 0.6, display: 'block', mb: 0.5 }}>Attachment</Typography>
                    <Card sx={{ borderRadius: '16px', border: '1px solid #e0e4e8', mb: 2, p: '12px' }}>
                        <div {...getRootProps()} style={{
                            border: '2px dashed #e0e4e8',
                            padding: '20px',
                            borderRadius: '12px',
                            textAlign: 'center',
                            backgroundColor: isDragActive ? '#f0f4f8' : '#fafafa'
                        }}>
                            <input {...getInputProps()} />
                            <CloudUploadIcon sx={{ color: '#bdc3c7', mb: 1 }} />
                            <Typography sx={{ fontSize: '11px', fontWeight: 700, color: '#151269' }}>
                                {documentFile ? 'Change File' : 'Select Document'}
                            </Typography>
                        </div>

                        {renderPreview}

                        {documentFile && (
                            <Box sx={{ mt: 2, p: '10px', bgcolor: '#f8f9fa', borderRadius: '8px', border: '1px solid #eee', position: 'relative' }}>
                                <IconButton
                                    onClick={handleClearDocument}
                                    size="small"
                                    sx={{ position: 'absolute', top: 4, right: 4, bgcolor: '#fff' }}
                                >
                                    <CloseIcon sx={{ fontSize: 14 }} />
                                </IconButton>
                                <FileDetail label="File" value={documentName} />
                                <Box sx={{ display: 'flex', gap: 1, mt: 0.5 }}>
                                    <Chip label={documentSize} size="small" sx={{ height: '16px', fontSize: '9px', fontWeight: 700 }} />
                                    <Chip label={documentType.split('/')[1]?.toUpperCase() || 'FILE'} color="primary" size="small" sx={{ height: '16px', fontSize: '9px', fontWeight: 700 }} />
                                </Box>
                            </Box>
                        )}
                    </Card>
                </Box>
            </div>
        </div>
    );
}

export default DocumentAddNew;